'use strict';

angular.module('licensure.helpers')
    .factory('Validation', ['$injector', '$q', function ($injector, $q) {
        // Helper Functions
        var isNumeric = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
        var isDate = function (date) {
            return !/Invalid|NaN/.test(new Date(date));
        }
        var parseDate = function (value) {
            if (isDate(value)) {
                return new Date(value.getFullYear(), value.getMonth(), value.getDate());
            }
            else { return null; }
        }
        var getDifferenceInDays = function (value) {
            var today = new Date();
            value.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            return Math.trunc((value.getTime() - today.getTime()) / 86400000);
        }


        // Functions for Validation Types
        var functions = {};
        functions.validateNumeric = function (n) {
            return isNumeric(n);
        }
        functions.validatePastDate = function (value) {
            var date = parseDate(value);
            var today = new Date();

            if (date != null) {
                return today > date;
            } else { return false; }
        }
        functions.validateToday = function (value) {
            var date = parseDate(value);
            var today = new Date();

            if (date != null) {
                today.setHours(0, 0, 0, 0);
                date.setHours(0, 0, 0, 0);
                return today.getTime() == date.getTime();
            } else { return false; }
        }
        functions.validateFutureDate = function (value) {
            var date = parseDate(value);
            var today = new Date();

            if (date != null) {
                return today < date;
            } else { return false; }
        }
        functions.validatePastDateToday = function (value) {
            return functions.validatePastDate(value) || functions.validateToday(value);
        }
        functions.validateFutureDateToday = function (value) {
            return functions.validateFutureDate(value) || functions.validateToday(value);
        }
        functions.validateNotToday = function (value) {
            return !functions.validateToday(value);
        }
        functions.validateDollar = function (value) {
            var re = /^((\d*)|(\$\d*)|(\d*\.\d{2})|(\$\d*\.\d{2})|(\-((\d*)|(\$\d*)|(\d*\.\d{2})|(\$\d*\.\d{2}))))$/;
            return re.test(value);
        }
        functions.validateDobEighteen = function (value) {
            var date = parseDate(value);
            var today = new Date();

            if (date != null) {
                today.setFullYear(parseInt(today.getFullYear()) - 18);
                return today.getTime() >= date.getTime();
            } else { return false; }
        }
        functions.validateDobSixteen = function (value) {
            var date = parseDate(value);
            var today = new Date();

            if (date != null) {
                today.setFullYear(parseInt(today.getFullYear()) - 16);
                return today.getTime() >= date.getTime();
            } else { return false; }
        }
        functions.validateGpsLatitude = function (value) {
            return /^(\+|-)?([9][0]|([1-8][0-9]|[0-9]|90)(\.[0-9]{1,6})?)*$/i.test(value);
        }
        functions.validateGpsLongitude = function (value) {
            return /^(\+|-)?([1][8][0]|([1][0-7][0-9]|[1-9][0-9]|[0-9]|90)(\.[0-9]{1,6})?)*$/i.test(value);
        }
        functions.validateWithin30Days = function (value) {
            var dateToCheck = parseDate(value);

            if (dateToCheck != null) {
                var diff = getDifferenceInDays(dateToCheck)
                
                if (diff <= 30 && diff >= 0) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        functions.validateWithin60Days = function (value) {
            var dateToCheck = parseDate(value);

            if (dateToCheck != null) {
                var diff = getDifferenceInDays(dateToCheck)
                
                if (diff <= 60 && diff >= 0) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        functions.validateWithin90Days = function (value) {
            var dateToCheck = parseDate(value);

            if (dateToCheck != null) {
                var diff = getDifferenceInDays(dateToCheck)
               
                if (diff <= 90 && diff >= 0) {
                    return true;
                } else {
                    return false;
                }
            }
        }


        // Functions for each kind of validation
        var validateMin = function (settings, value) {
            return (isNumeric(settings.min_length) && value.length >= settings.min_length);
        }

        var validateMax = function (settings, value) {
            return (isNumeric(settings.max_length) && value.length <= settings.max_length);
        }

        var validateType = function (settings, value) {
            var result = functions[settings.validation_type_method](value);
            return result;
        }

        var validateExpression = function (settings, value) {
            if (typeof (value) == "string") {
                if (isValidGuid(value)) {
                    value = value.toUpperCase();
                }
            }
            if (typeof (value) == "object" && value.length > 0) {
                var tempString = "";
                value = value.map(function (a) { tempString += (a.id.toString().toUpperCase()+",") });
                value = tempString;
            }
            var regexString = settings.expression;
            var regex = new RegExp(regexString);
            return !value || regex.test(value);
        }

        return {
            // Main validation function
            validateQuestion: function (input, validation, value) {
                var d = $q.defer();
                if (validation) {
                    var result = true;
                    if (value) {
                        if (validation.min_length) {
                            var minResult = validateMin(validation, value);
                            if (input != null) {
                                input.$setValidity("min", minResult);
                                input.$setDirty(); //validation is run on page load, so have to set to dirty to get it to display
                            }
                            result = result && minResult;
                        }
                        if (validation.max_length) {
                            var maxResult = validateMax(validation, value);
                            if (input != null) {
                                input.$setValidity("max", maxResult);
                                input.$setDirty();
                            }
                            result = result && maxResult;
                        }
                        if (validation.validation_type_id) {
                            var typeResult = validateType(validation, value);
                            if (input != null) {
                                input.$setValidity("type", typeResult);
                                input.$setDirty();
                            }
                            result = result && typeResult;
                        }
                        if (validation.expression) {
                            var expResult = validateExpression(validation, value);
                            if (input != null) {
                                input.$setValidity("expression", expResult);
                                input.$setDirty();
                            }
                            result = result && expResult;
                        }
                    }
                    if (validation.function && typeof validation.function == "function") {
                        validation.function(value).then(function (funcResult) {
                            if (input != null) {
                                input.$setValidity("customFunction", funcResult);
                                input.$setDirty();
                            }
                            result = result && funcResult;
                            d.resolve(result);
                        });
                    } else {
                        d.resolve(result);
                    }
                } else {
                    // If there's no validation, it's valid
                    d.resolve(true);
                }
                return d.promise;
            }

        }
    }])
;